import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-base-page',
    templateUrl: './base-page.component.html',
    styleUrls: ['./base-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BasePageComponent {
    constructor() {
    }
}
